<div *ngIf="conference" class="bg-dark w-100 vh-100" style="background-image: url('https://bxlimages.blob.core.windows.net/images/{{conference.checkInBGSplash}}')">
  <div class="w-100 text-center pt-2 pb-2 bg-dark" style="opacity: 0.5">
    <img style="height: 70px" src="../../../assets/logo-dark-bg.png"/>
  </div>

  <div style="height: 70vh" class="container-fluid d-md-flex  position-relative  space-bottom-3  space-bottom-md-0">
    <div class="w-100 text-center">
      <img alt="logo" style="margin-left: auto; margin-right: auto; max-height: 200px" class="mb-6" src="https://bxlimages.blob.core.windows.net/images/{{conference.checkInFGSplash}}"/>

      <div *ngIf="!conference.registrationOpen && !auth.isSuperUser()" class="card container p-3 w-100 text-center" style="opacity: 0.95">
        <div class="w-100 mb-5">
          <h1 class="display-5">Registration is closed</h1>
          <h4>Please check the program for registration hours</h4>
        </div>
      </div>

      <ng-container *ngIf="conference.registrationOpen || auth.isSuperUser()">
        <div *ngIf="!checkInMode && !reKeyMode && checkinService.rfidEnabled" class="row mx-gutters-2 d-flex justify-content-center">
          <div class="mr-5 mb-3 mb-md-0">
            <button type="button" class="btn btn-lg bg-white" (click)="checkInClicked()" style="height: 15rem;width: 15rem;">
              <i style="font-size: 5rem;" class=" fas fa-users"></i>
              <span class="mt-2 d-block">Check In</span>
            </button>

          </div>
          <!--        <div class="mr-5 mb-3 mb-md-0">-->
          <!--          <button type="button" class="btn btn-lg bg-white" (click)="registerClicked()" style="height: 15rem;width: 15rem;">-->
          <!--            <i style="font-size: 5rem;" class=" fas fa-store"></i>-->
          <!--            <span class="mt-2 d-block">Register/Purchase</span>-->
          <!--          </button>-->

          <!--        </div>-->
          <div class="mb-3 mb-md-0" *ngIf="checkinService.rfidEnabled">
            <button type="button" class="btn btn-lg bg-white" (click)="rfidClicked()" style="height: 15rem;width: 15rem;">
              <i style="font-size: 5rem;" class=" fas fa-tablet-android"></i>
              <span class="mt-2 d-block">Re-Issue/Add RFID</span>
            </button>

          </div>
        </div>
      </ng-container>
      <div *ngIf="(checkInMode || reKeyMode ||  !checkinService.rfidEnabled) && (conference.registrationOpen || auth.isSuperUser())" class="card container p-3 w-100 text-center" style="opacity: 0.95">
        <div class="w-100 mb-5">
          <h1 *ngIf="checkInMode" class="display-5">Conference Check-in</h1>
          <h1 *ngIf="reKeyMode" class="display-5">Re-Issue RFID Tag</h1>
          <h5>Enter your name or email address to look up your registration</h5>
        </div>

        <div class="w-100 mb-5">

          <form #myForm="ngForm" class="js-validate" novalidate="novalidate">
            <div class="d-flex pr-5 pl-5">
              <input (focus)="onInputFocus($event)" (mouseup)="mouseUp($event)" (change)="onInputChange($event)" #email type="text" class="mr-2 form-control" name="name" id="name" [(ngModel)]="model.searchText" placeholder="Search by name or email address..." aria-label="Name" required/>
              <button type="submit" style="white-space: nowrap" class=" mr-2 btn  btn-admin-primary transition-3d-hover" [promiseBtn]="submitComplete" (click)="checkin(popupContent)">Continue</button>
              <button type="button" class="btn  btn-secondary transition-3d-hover" (click)="cancel()">Cancel</button>

            </div>


          </form>

        </div>
      </div>
    </div>
  </div>


</div>
<ng-template #popupContent let-modal>
  <div class="p-4">
    <div class="d-flex align-items-center mb-1">
      <div>Multiple Records Found. Please choose one...</div>
      <button class="btn btn-sm btn-secondary ml-auto" (click)="modal.close(); this.reset()">Cancel</button>
    </div>

    <div class="mb-1" *ngFor="let result of searchResults">
      <div (click)="resultSelected(result, modal)" class="card">
        <div class="card-body p-4">
          <h4 class="mb-0">{{ result.fullNameWithCredentials }}</h4>
          <h6 class="mb-0">{{ result.email }}</h6>
        </div>
      </div>
    </div>


  </div>
</ng-template>
<div class="bg-light" [ngStyle]="{ display: keyboardVisible ? 'block' : 'none' }" style="position:absolute; bottom:0;left:0;right:0;">
  <div style="">
    <div class="simple-keyboard"></div>
  </div>
</div>
